import { UserLongTask } from "@/model/data/userLongTasks/UserLongTask";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetUserLongTasksResponse extends ServiceResponseData {
    userLongTaskList: UserLongTask[];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            const data = response.data.Payload;

            this.userLongTaskList = [];
            data.UserLongTaskList.forEach((v: any) => {
                var entry = new UserLongTask();
                entry.parse(v);
                this.userLongTaskList.push(entry);
            });
        }
    }
}
